import React, { useState, useEffect } from "react";
import { endPoints } from "../../constant/Environment";
import { addData, deleteData, getAllData } from "../../Utility/API";
import { Modal, Form, Button } from "react-bootstrap";
import Toaster from "../../components/Toast";
import Loader from "../../components/Loader";
import PageHeader from "../../components/PageHeader";
import { ErrorToast, SuccesToast } from "../../components/Toast/message";
import DeleteModel from "../../components/DeleteModel";

import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import IconButton from "@mui/material/IconButton";
import FirstPageIcon from "@mui/icons-material/FirstPage";
import KeyboardArrowLeft from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRight from "@mui/icons-material/KeyboardArrowRight";
import LastPageIcon from "@mui/icons-material/LastPage";
import { useTheme } from "@mui/material/styles";
import Box from "@mui/material/Box";
import TableFooter from "@mui/material/TableFooter";
import TablePagination from "@mui/material/TablePagination";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import VisibilityIcon from "@mui/icons-material/Visibility";

function TablePaginationActions(props) {
  const theme = useTheme();
  const { count, page, rowsPerPage, onPageChange } = props;

  const handleFirstPageButtonClick = (event) => {
    onPageChange(event, 0);
  };
  const handleBackButtonClick = (event) => {
    onPageChange(event, page - 1);
  };
  const handleNextButtonClick = (event) => {
    onPageChange(event, page + 1);
  };
  const handleLastPageButtonClick = (event) => {
    onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
  };

  return (
    <Box sx={{ flexShrink: 0, ml: 2.5 }}>
      <IconButton onClick={handleFirstPageButtonClick} disabled={page === 0} aria-label="first page">
        {theme.direction === "rtl" ? <LastPageIcon /> : <FirstPageIcon />}
      </IconButton>
      <IconButton onClick={handleBackButtonClick} disabled={page === 0} aria-label="previous page">
        {theme.direction === "rtl" ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}
      </IconButton>
      <IconButton
        onClick={handleNextButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="next page"
      >
        {theme.direction === "rtl" ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
      </IconButton>
      <IconButton
        onClick={handleLastPageButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="last page"
      >
        {theme.direction === "rtl" ? <FirstPageIcon /> : <LastPageIcon />}
      </IconButton>
    </Box>
  );
}

const StreakTypes = () => {
  const [rows, setRows] = useState([]);
  const [packages, setPackages] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const [editData, setEditData] = useState({});
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);

  const [viewData, setViewData] = useState(null);
  const [showView, setShowView] = useState(false);

  const [rowDataToDelete, setRowDataToDelete] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);

  // form fields
  const [streak, setStreak] = useState("");
  const [sc, setSc] = useState("");
  const [gc, setGc] = useState("");
  const [freeSpin, setFreeSpin] = useState("");
  const [coinPackageId, setCoinPackageId] = useState("");
  const [isActive, setIsActive] = useState("1");
  const [specifications, setSpecifications] = useState("");
  const [termsAndConditions, setTermsAndConditions] = useState("");

  // pagination
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);

  useEffect(() => {
    fetchStreakTypes();
    fetchPackages();
  }, []);

  useEffect(() => {
    setStreak(editData?.streak != null ? String(editData.streak) : "");
    setSc(editData?.sc != null ? editData.sc : "");
    setGc(editData?.gc != null ? editData.gc : "");
    setFreeSpin(editData?.freeSpin != null ? editData.freeSpin : "");
    setCoinPackageId(editData?.coinPackageId != null ? String(editData.coinPackageId) : "");
    setIsActive(editData?.isActive != null ? String(editData.isActive) : "1");
    setSpecifications(editData?.specifications || "");
    setTermsAndConditions(editData?.termsAndConditions || "");
  }, [editData]);

  const fetchStreakTypes = async () => {
    setIsLoading(true);
    try {
      const response = await getAllData(`${endPoints.api.GET_ALL_STREAK_TYPES}`);
      // /all returns a raw array; tolerate a wrapped { data } shape too
      const data = Array.isArray(response) ? response : response?.data || [];
      setRows(data);
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  const fetchPackages = async () => {
    try {
      const response = await getAllData(`${endPoints.api.GET_PACKAGE}`);
      const data = response?.status === "success" ? response?.data : response?.data || response;
      setPackages(Array.isArray(data) ? data : []);
    } catch (error) {
      console.error(error);
    }
  };

  const packageLabel = (id) => {
    if (id == null || id === "") return "-";
    const match = packages.find((p) => String(p?.id) === String(id));
    return match ? `$${match.purchase_price}` : `-`;
  };

  const handleOk = () => {
    // All fields are mandatory
    if (
      streak === "" ||
      sc === "" ||
      gc === "" ||
      freeSpin === "" ||
      coinPackageId === "" ||
      isActive === "" ||
      String(specifications).trim() === "" ||
      String(termsAndConditions).trim() === ""
    ) {
      ErrorToast("All fields are required");
      return;
    }

    const streakDays = Number(streak);
    if (!Number.isInteger(streakDays) || streakDays <= 1) {
      ErrorToast("Streak days must be a whole number greater than 1");
      return;
    }

    // Don't allow two streak types with the same number of days (ignore the row being edited)
    const duplicate = rows.find(
      (r) => Number(r?.streak) === streakDays && String(r?.id) !== String(editData?.id)
    );
    if (duplicate) {
      ErrorToast(`A ${streakDays}-day streak type already exists`);
      return;
    }

    const url = editData?.id
      ? `${endPoints.api.UPDATE_STREAK_TYPE}`
      : `${endPoints.api.CREATE_STREAK_TYPE}`;

    const payload = {
      streak: Number(streak),
      sc: sc === "" ? 0 : Number(sc),
      gc: gc === "" ? 0 : Number(gc),
      freeSpin: freeSpin === "" ? 0 : Number(freeSpin),
      coinPackageId: coinPackageId === "" ? null : Number(coinPackageId),
      isActive: Number(isActive),
      specifications: specifications,
      termsAndConditions: termsAndConditions,
    };
    if (editData?.id) {
      payload.id = editData.id;
    }

    setIsLoading(true);
    addData(url, payload)
      .then((response) => {
        setIsLoading(false);
        if (response?.data?.status === "success") {
          SuccesToast(response?.data?.message || "Saved Successfully");
          fetchStreakTypes();
          handleClose();
        } else {
          ErrorToast(response?.data?.message || "Something went wrong");
        }
      })
      .catch((error) => {
        setIsLoading(false);
        console.error(error);
        ErrorToast("Something went wrong");
      });
  };

  const handleView = (row) => {
    setViewData(row);
    setShowView(true);
  };

  const handleDelete = (row) => {
    setRowDataToDelete(row);
    setShowDeleteModal(true);
  };

  const deleteStreakType = () => {
    const id = rowDataToDelete?.id;
    setIsLoading(true);
    deleteData(`${endPoints.api.DELETE_STREAK_TYPE}${id}`)
      .then((response) => {
        setIsLoading(false);
        if (response?.status === 200 || response?.data?.status === "success") {
          setShowDeleteModal(false);
          fetchStreakTypes();
          SuccesToast("Deleted Successfully");
        } else {
          ErrorToast(response?.data?.message || "Failed to delete");
        }
      })
      .catch((error) => {
        console.error(error);
        setIsLoading(false);
      });
  };

  const emptyRows =
    page > 0 ? Math.max(0, (1 + page) * rowsPerPage - rows.length) : 0;

  const handleChangePage = (event, newPage) => setPage(newPage);
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  return (
    <>
      <div className="main">
        <Toaster></Toaster>
        <DeleteModel
          showModal={showDeleteModal}
          onClose={() => setShowDeleteModal(false)}
          onDelete={deleteStreakType}
        />
        {isLoading && <Loader spinner={true} visible={isLoading} />}
        <div id="Sportbook" style={{ padding: "0px" }}>
          <div className="container-fluid bg-color-sportbook custom-card4">
            <div className="inner-space1">
              <PageHeader title="Streak Config" crumb="Promotions / Streak Config" />

              <div style={{ marginTop: "10px" }}>
                <div className="row">
                  <div className="col-md-12">
                    <TableContainer component={Paper}>
                      <Table
                        className="c_table"
                        size="small"
                        stickyHeader
                        sx={{ minWidth: 500 }}
                        aria-label="streak types table"
                      >
                        <TableHead>
                          <TableRow>
                            <TableCell align="center">Streak (Days)</TableCell>
                            <TableCell align="center">Cash</TableCell>
                            <TableCell align="center">Bonus</TableCell>
                            <TableCell align="center">Free Spin</TableCell>
                            <TableCell align="center">Recovery Package</TableCell>
                            <TableCell align="center">Status</TableCell>
                            <TableCell align="center">Options</TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {(rowsPerPage > 0
                            ? rows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                            : rows
                          ).map((row, index) => (
                            <TableRow
                              key={row?.id || index}
                              sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                            >
                              <TableCell align="center">{row?.streak}</TableCell>
                              <TableCell align="center">{row?.sc}</TableCell>
                              <TableCell align="center">{row?.gc}</TableCell>
                              <TableCell align="center">{row?.freeSpin}</TableCell>
                              <TableCell align="center">{packageLabel(row?.coinPackageId)}</TableCell>
                              <TableCell align="center">
                                {row?.isActive === 1 ? "Active" : "Inactive"}
                              </TableCell>
                              <TableCell align="center">
                                <VisibilityIcon
                                  style={{ cursor: "pointer" }}
                                  onClick={() => handleView(row)}
                                />
                                <EditIcon
                                  style={{ cursor: "pointer" }}
                                  onClick={() => {
                                    setShow(true);
                                    setEditData(row);
                                  }}
                                />
                              </TableCell>
                            </TableRow>
                          ))}

                          {emptyRows > 0 && (
                            <TableRow style={{ height: 53 * emptyRows }}>
                              <TableCell colSpan={8} />
                            </TableRow>
                          )}
                        </TableBody>
                        <TableFooter>
                          <TableRow>
                            <TablePagination
                              rowsPerPageOptions={[5, 10, 25, { label: "All", value: -1 }]}
                              colSpan={8}
                              count={rows.length}
                              rowsPerPage={rowsPerPage}
                              page={page}
                              SelectProps={{
                                inputProps: { "aria-label": "rows per page" },
                                native: true,
                              }}
                              onPageChange={handleChangePage}
                              onRowsPerPageChange={handleChangeRowsPerPage}
                              ActionsComponent={TablePaginationActions}
                            />
                          </TableRow>
                        </TableFooter>
                      </Table>
                    </TableContainer>
                  </div>

                  {/* Add / Edit Modal */}
                  <Modal show={show} onHide={handleClose} size="lg">
                    <Modal.Header closeButton>
                      <Modal.Title id="contained-modal-title-vcenter">
                        {editData?.id ? "Edit Streak Type" : "Add Streak Type"}
                      </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                      <div className="row">
                        <div className="col-md-6">
                          <Form.Group className="mb-3" controlId="streak">
                            <Form.Label>Streak Length (Days)</Form.Label>
                            <Form.Control
                              type="number"
                              min={2}
                              placeholder="Enter number of days"
                              value={streak}
                              onChange={(event) => setStreak(event.target.value)}
                            />
                          </Form.Group>
                        </div>
                        <div className="col-md-6">
                          <Form.Group className="mb-3" controlId="isActive">
                            <Form.Label>Status</Form.Label>
                            <Form.Select
                              value={isActive}
                              onChange={(event) => setIsActive(event.target.value)}
                            >
                              <option value="1">Active</option>
                              <option value="0">Inactive</option>
                            </Form.Select>
                          </Form.Group>
                        </div>
                        <div className="col-md-6">
                          <Form.Group className="mb-3" controlId="sc">
                            <Form.Label>Cash</Form.Label>
                            <Form.Control
                              type="number"
                              placeholder="Total Cash reward"
                              value={sc}
                              onChange={(event) => setSc(event.target.value)}
                            />
                          </Form.Group>
                        </div>
                        <div className="col-md-6">
                          <Form.Group className="mb-3" controlId="gc">
                            <Form.Label>Bonus</Form.Label>
                            <Form.Control
                              type="number"
                              placeholder="Total Bonus reward"
                              value={gc}
                              onChange={(event) => setGc(event.target.value)}
                            />
                          </Form.Group>
                        </div>
                        <div className="col-md-6">
                          <Form.Group className="mb-3" controlId="freeSpin">
                            <Form.Label>Free Spin</Form.Label>
                            <Form.Control
                              type="number"
                              placeholder="Total free spins"
                              value={freeSpin}
                              onChange={(event) => setFreeSpin(event.target.value)}
                            />
                          </Form.Group>
                        </div>
                        <div className="col-md-6">
                          <Form.Group className="mb-3" controlId="coinPackageId">
                            <Form.Label>Recovery Package</Form.Label>
                            <Form.Select
                              value={coinPackageId}
                              onChange={(event) => setCoinPackageId(event.target.value)}
                            >
                              <option value="">Select Recovery Package</option>
                              {packages.map((p) => (
                                <option key={p?.id} value={p?.id}>
                                  ${p?.purchase_price}
                                </option>
                              ))}
                            </Form.Select>
                          </Form.Group>
                        </div>
                        <div className="col-md-12">
                          <Form.Group className="mb-3" controlId="specifications">
                            <Form.Label>Specifications</Form.Label>
                            <Form.Control
                              as="textarea"
                              rows={2}
                              placeholder="Feature / specification text shown on the plan picker"
                              value={specifications}
                              onChange={(event) => setSpecifications(event.target.value)}
                            />
                          </Form.Group>
                        </div>
                        <div className="col-md-12">
                          <Form.Group className="mb-3" controlId="termsAndConditions">
                            <Form.Label>Terms &amp; Conditions</Form.Label>
                            <Form.Control
                              as="textarea"
                              rows={2}
                              placeholder="Terms and conditions text"
                              value={termsAndConditions}
                              onChange={(event) => setTermsAndConditions(event.target.value)}
                            />
                          </Form.Group>
                        </div>
                      </div>
                    </Modal.Body>
                    <Modal.Footer>
                      <Button
                        onClick={handleOk}
                        style={{ background: "#04631e", borderColor: "#04631e" }}
                      >
                        {editData?.id ? "Update" : "Apply"}
                      </Button>
                    </Modal.Footer>
                  </Modal>

                  {/* Detail (View) Modal */}
                  <Modal show={showView} onHide={() => setShowView(false)} size="lg">
                    <Modal.Header closeButton>
                      <Modal.Title>Streak Type Details</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                      {viewData && (
                        <div className="row">
                          <div className="col-md-6 mb-3">
                            <strong>ID:</strong> {viewData.id}
                          </div>
                          <div className="col-md-6 mb-3">
                            <strong>Streak (Days):</strong> {viewData.streak}
                          </div>
                          <div className="col-md-6 mb-3">
                            <strong>Cash:</strong> {viewData.sc}
                          </div>
                          <div className="col-md-6 mb-3">
                            <strong>Bonus:</strong> {viewData.gc}
                          </div>
                          <div className="col-md-6 mb-3">
                            <strong>Free Spin:</strong> {viewData.freeSpin}
                          </div>
                          <div className="col-md-6 mb-3">
                            <strong>Recovery Package:</strong> {packageLabel(viewData.coinPackageId)}
                          </div>
                          <div className="col-md-6 mb-3">
                            <strong>Status:</strong>{" "}
                            {viewData.isActive === 1 ? "Active" : "Inactive"}
                          </div>
                          <div className="col-md-12 mb-3">
                            <strong>Specifications:</strong> {viewData.specifications || "-"}
                          </div>
                          <div className="col-md-12 mb-3">
                            <strong>Terms &amp; Conditions:</strong>{" "}
                            {viewData.termsAndConditions || "-"}
                          </div>
                        </div>
                      )}
                    </Modal.Body>
                    <Modal.Footer>
                      <Button
                        onClick={() => setShowView(false)}
                        style={{ background: "#04631e", borderColor: "#04631e" }}
                      >
                        Close
                      </Button>
                    </Modal.Footer>
                  </Modal>
                </div>
              </div>

              <div style={{ display: "flex", justifyContent: "end", marginTop: "20px" }}>
                <Button
                  variant="primary"
                  style={{ background: "#04631e", borderColor: "#04631e" }}
                  onClick={() => {
                    setShow(true);
                    setEditData({});
                  }}
                >
                  Add New Streak Type
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default StreakTypes;
